// The uploaded photo, shown as a small thumbnail on the confirm/review
// steps and expandable in place on click — so the user can compare the
// extracted fields against what they actually snapped.
import { useState } from 'react';

interface PhotoThumbnailProps {
  src: string;
}

export function PhotoThumbnail({ src }: PhotoThumbnailProps): React.JSX.Element {
  const [expanded, setExpanded] = useState(false);
  return (
    <button
      type="button"
      aria-expanded={expanded}
      aria-label={expanded ? 'Shrink your photo' : 'Expand your photo'}
      onClick={() => setExpanded((open) => !open)}
      className={`block overflow-hidden rounded-2xl border border-border bg-muted p-0 transition-all ${
        expanded ? 'w-full' : 'h-16 w-16'
      }`}
    >
      <img
        src={src}
        alt="Your photo"
        className={`${expanded ? 'w-full' : 'h-16 w-16'} object-cover`}
      />
    </button>
  );
}
